import { ThirdPartyTrackingPermissionChecker } from "./ThirdPartyTrackingPermissionChecker";
import { InternalTrackingPermissionChecker } from "./InternalTrackingPermissionChecker";
import { ScopedTrackingPermissionChecker } from "./ScopedTrackingPermissionChecker";
import { WindowLocationWrapper } from "../window_wrapping/WindowLocationWrapper";
import { QueryStringValuesAccessor } from "../query_string/QueryStringValuesAccessor";
import { EnvironmentTrackingPermissionChecker } from "./EnvironmentTrackingPermissionChecker";
import { CachedTrackingPermissionChecker } from "./CachedTrackingPermissionChecker";
import { TrackingScope } from "./TrackingScope";
import { TrackingPermissionChecker } from "./TrackingPermissionChecker";
import { DefaultScopedTrackingPermissionChecker } from "./DefaultScopedTrackingPermissionChecker";

/**
 * Creates a new instance of a scoped permissions checker.
 *
 * @param windowLocation The wrapper over the window location.
 * @param queryStringValuesAccessor A utility for accessing query string values.
 * @returns A new instance of a scoped permissions checker.
 */
export function createScopedPermissionsChecker(
	windowLocation: WindowLocationWrapper,
	queryStringValuesAccessor: QueryStringValuesAccessor
): ScopedTrackingPermissionChecker {
	const internalTrackingPermissionChecker =
		new InternalTrackingPermissionChecker();
	const cachedInternalTrackingPermissionChecker =
		new CachedTrackingPermissionChecker(internalTrackingPermissionChecker);
	const thirdPartyTrackingPermissionChecker =
		new ThirdPartyTrackingPermissionChecker(
			windowLocation,
			cachedInternalTrackingPermissionChecker
		);
	const cachedThirdPartyTrackingPermissionChecker =
		new CachedTrackingPermissionChecker(thirdPartyTrackingPermissionChecker);
	const environmentTrackingPermissionChecker =
		new EnvironmentTrackingPermissionChecker(
			windowLocation,
			queryStringValuesAccessor
		);
	const cachedEnvironmentTrackingPermissionChecker =
		new CachedTrackingPermissionChecker(environmentTrackingPermissionChecker);
	const permissionCheckerByScopeMap: Record<
		TrackingScope,
		TrackingPermissionChecker
	> = {
		[TrackingScope.Internal]: cachedInternalTrackingPermissionChecker,
		[TrackingScope.ThirdParty]: cachedThirdPartyTrackingPermissionChecker,
		[TrackingScope.Environment]: cachedEnvironmentTrackingPermissionChecker,
	};
	return new DefaultScopedTrackingPermissionChecker(
		permissionCheckerByScopeMap
	);
}
